<template>
  <div class>
    <!-- header start -->
    <van-nav-bar
      title="我的订单"
      fixed
      :z-index="99"
      left-arrow
      @click-left="onClickLeft"
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->

  <van-tabs
      sticky
      offset-top="46"
      title-active-color="#fff"
      title-inactive-color="#f2f2f2"
      background="#24a378"
      color="#fff"
      :border="false"
    >
      <van-tab title="全部">
        <order_list  ></order_list>
      </van-tab>
      <van-tab title="待付款">
        <order_list :PayStatus="0" ></order_list>
        <!-- <van-empty description="暂无" /> -->
      </van-tab>
      <van-tab title="已完成">
        <order_list :PayStatus="1" ></order_list>
        <!-- <van-empty description="暂无" /> -->
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import order_list from "@/components/order_list";
export default {
  data() {
    return {
      dataList:null
    };
  },
  components: {
    order_list
  },
  mounted() {
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#f2f2f2");
  },
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>

</style>
